import { gql, useMutation } from '@apollo/client';

import type { UpdateFamilyMutation, UpdateFamilyMutationVariables } from './__generated__/useUpdateFamily.gql';

const UPDATE_FAMILY = gql`
  mutation UpdateFamily($input: UpdateFamilyInput!) {
    updateFamily(input: $input) {
      id
      name
    }
  }
`;

/**
 * Renames the caller's household. The mutation takes the family from the
 * session, so the only argument is the new name; it must be non-empty, as
 * `FamilyController` trims and rejects a blank one.
 *
 * @returns the standard `useMutation` tuple — `[updateFamily, { loading, error }]`.
 */
export const useUpdateFamily = () => {
  return useMutation<UpdateFamilyMutation, UpdateFamilyMutationVariables>(UPDATE_FAMILY);
};
